import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const AuditQueueSchema = withDefaults({
  'type': 'audit-queue',
  'fields': [
    {
      'kind': 'attribute',
      'name': 'decidedAt'
    },
    {
      'kind': 'attribute',
      'name': 'decidedBy'
    },
    {
      'kind': 'attribute',
      'name': 'actionTaken'
    },
    {
      'kind': 'attribute',
      'name': 'auditFlag'
    },
    {
      'kind': 'attribute',
      'name': 'auditReason'
    },
    {
      'kind': 'attribute',
      'name': 'auditStatus'
    },
    {
      'kind': 'attribute',
      'name': 'markedForAudit'
    },
    {
      'kind': 'attribute',
      'name': 'devNote'
    },
    {
      'kind': 'attribute',
      'name': 'requestedAmountCents'
    },
    {
      'kind': 'attribute',
      'name': 'robotApprovedAmountCents'
    },
    {
      'kind': 'attribute',
      'name': 'personApprovedAmountCents'
    },
    {
      'kind': 'attribute',
      'name': 'availableFundsCents'
    },
    {
      'kind': 'attribute',
      'name': 'robotConfidenceLevel'
    },
    {
      'kind': 'attribute',
      'name': 'logTransitionId'
    },
    {
      'kind': 'attribute',
      'name': 'tasApplicationId'
    },
    {
      'kind': 'attribute',
      'name': 'companyId'
    },
    {
      'kind': 'attribute',
      'name': 'aiRecommendationId'
    },
    {
      'kind': 'attribute',
      'name': 'createdAt'
    },
    {
      'kind': 'attribute',
      'name': 'updatedAt'
    },
    {
      'kind': 'attribute',
      'name': 'applicantName'
    },
    {
      'kind': 'attribute',
      'name': 'companyNameDisplay'
    },
    {
      'kind': 'attribute',
      'name': 'programNameDisplay'
    },
    {
      'kind': 'attribute',
      'name': 'applicationName'
    },
    {
      'kind': 'attribute',
      'name': 'courseCash'
    },
    {
      'kind': 'attribute',
      'name': 'robotRecAction'
    },
    {
      'kind': 'attribute',
      'name': 'evalVote'
    },
    {
      'kind': 'attribute',
      'name': 'evaluatedAt'
    },
    {
      'kind': 'attribute',
      'name': 'evaluationPresent'
    },
    {
      'kind': 'attribute',
      'name': 'evaluatorVerdict'
    },
    {
      'kind': 'attribute',
      'name': 'auditLogPresent'
    },
    {
      'kind': 'attribute',
      'name': 'escalationRequested'
    },
    {
      'kind': 'attribute',
      'name': 'auditedBy'
    },
    {
      'kind': 'attribute',
      'name': 'auditedAt'
    },
    {
      'kind': 'attribute',
      'name': 'deliveredMessage'
    },
    {
      'kind': 'attribute',
      'name': 'originalDeliveredMessage'
    },
    {
      'kind': 'attribute',
      'name': 'originalDecisionNote'
    },
    {
      'kind': 'attribute',
      'name': 'robotRecNote'
    },
    {
      'kind': 'attribute',
      'name': 'evalComments'
    },
    {
      'kind': 'attribute',
      'name': 'auditOutcome'
    },
    {
      'kind': 'attribute',
      'name': 'nextPaymentRunAt'
    },
    {
      'kind': 'attribute',
      'name': 'lastPaymentRunAt'
    },
    {
      'kind': 'attribute',
      'name': 'canFlagForAudit'
    },
    {
      'kind': 'attribute',
      'name': 'flaggedAt'
    },
    {
      'kind': 'attribute',
      'name': 'flaggedByName'
    },
    {
      'kind': 'attribute',
      'name': 'removedAt'
    },
    {
      'kind': 'attribute',
      'name': 'removedByName'
    },
    {
      'kind': 'attribute',
      'name': 'removalNote'
    },
    {
      'kind': 'attribute',
      'name': 'canCorrect'
    },
    {
      'kind': 'attribute',
      'name': 'canSendBack'
    },
    {
      'kind': 'attribute',
      'name': 'correctionApplied'
    },
    {
      'kind': 'attribute',
      'name': 'correctionReachesApplication'
    },
    {
      'kind': 'attribute',
      'name': 'reopenedAt'
    },
    {
      'kind': 'attribute',
      'name': 'reopenedByName'
    },
    {
      'kind': 'attribute',
      'name': 'reopenNote'
    },
    {
      'kind': 'attribute',
      'name': 'canExcludeFromMetrics'
    },
    {
      'kind': 'attribute',
      'name': 'metricsExcludedAt'
    },
    {
      'kind': 'attribute',
      'name': 'metricsExcludedByName'
    },
    {
      'kind': 'attribute',
      'name': 'metricsExclusionReason'
    },
    {
      'kind': 'attribute',
      'name': 'decisionSuperseded'
    },
    {
      'kind': 'attribute',
      'name': 'canEscalate'
    },
    {
      'kind': 'attribute',
      'name': 'canRecordSupersededAudit'
    },
    {
      'kind': 'attribute',
      'name': 'canRecallEscalation'
    },
    {
      'kind': 'attribute',
      'name': 'supersedingLogTransitionId'
    },
    {
      'kind': 'attribute',
      'name': 'supersededReason'
    },
    {
      'kind': 'attribute',
      'name': 'supersedingAuditQueueId'
    },
    {
      'kind': 'attribute',
      'name': 'supersedingDecidedBy'
    },
    {
      'kind': 'attribute',
      'name': 'supersedingActionTaken'
    },
    {
      'kind': 'attribute',
      'name': 'supersedingDecidedAt'
    },
    {
      'kind': 'attribute',
      'name': 'supersededAuditQueueId'
    },
    {
      'kind': 'attribute',
      'name': 'supersededDecidedBy'
    },
    {
      'kind': 'attribute',
      'name': 'supersededActionTaken'
    },
    {
      'kind': 'attribute',
      'name': 'supersededDecidedAt'
    },
    {
      'kind': 'attribute',
      'name': 'amountChangedSinceDecision'
    },
    {
      'kind': 'attribute',
      'name': 'amountLastEditedBy'
    },
    {
      'kind': 'attribute',
      'name': 'amountLastEditedAt'
    },
    {
      'kind': 'attribute',
      'name': 'amountLastEditedToCents'
    },
    {
      'kind': 'hasMany',
      'name': 'auditLogs',
      'type': 'audit-log',
      'options': {
        'async': false,
        'inverse': null
      }
    }
  ]
});

export default AuditQueueSchema;
